// extracted by mini-css-extract-plugin
export default {"subtitle":"G57cafd G519ebe"};